import { render, staticRenderFns } from "./ProcessDefinitionStepAttributes.vue?vue&type=template&id=1735030f&scoped=true&"
import script from "./ProcessDefinitionStepAttributes.vue?vue&type=script&lang=js&"
export * from "./ProcessDefinitionStepAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDefinitionStepAttributes.vue?vue&type=style&index=0&id=1735030f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735030f",
  null
  
)

export default component.exports